import cx from 'classnames';
import React from 'react';
import ID from './UUID.jsx';
import bt from './bootstrap.module.css';
import { Sizes } from './form-edits-components/Size';
import icons from './icons/index.js';
import store from './stores/store';
import ToolbarItem from './toolbar-draggable-item.jsx';

export const ItemsTypes = {
  Title: 'title',
  Paragraph: 'paragraph',
  TextInput: 'text_input',
  Select: 'select',
  MultiLineInput: 'multi_line_input',
  SingleChoice: 'single_choice',
  MultipleChoice: 'multiple_choice',
  Line: 'line',
  TwoColumnLayout: 'two_column_layout',
  ThreeColumnLayout: 'three_column_layout',
  FileUpload: 'file_upload',
  Hint: 'hint',
  Video: 'video',
  Date: 'date',
  Signature: 'signature',
};

const items = [
  {
    type: ItemsTypes.Title,
    name: 'Title',
    icon: icons.Header,
    group: 'text',
    haveSize: true,
    haveText: true,
    canBeRedacted: true,
  },
  {
    type: ItemsTypes.Paragraph,
    name: 'Paragraph',
    icon: icons.Paragraph,
    group: 'text',
    haveSize: true,
    haveText: true,
    canBeRedacted: true,
  },
  {
    type: ItemsTypes.TextInput,
    name: 'Text input',
    icon: icons.TextInput,
    group: 'inputs',
    haveLabel: true,
    canBeValidated: true,
    canBeRequired: true,
    havePlaceholder: true,
    canBeRedacted: true,
    canBeReportable: true,
  },
  {
    type: ItemsTypes.Select,
    name: 'Select',
    icon: icons.Select,
    group: 'select',
    haveLabel: true,
    canBeRequired: true,
    haveOptions: true,
    canBeRedacted: true,
    canBeReportable: true,
  },
  {
    type: ItemsTypes.MultiLineInput,
    name: 'Multiline input',
    icon: icons.MultiLineInput,
    group: 'inputs',
    haveLabel: true,
    canBeRequired: true,
    havePlaceholder: true,
    canBeRedacted: true,
    canBeReportable: true,
  },
  {
    type: ItemsTypes.Date,
    name: 'Date',
    icon: icons.Calendar,
    group: 'inputs',
    haveLabel: true,
    havePlaceholder: true,
    canBeRequired: true,
    canBeRedacted: true,
  },
  {
    type: ItemsTypes.SingleChoice,
    name: 'Single choice',
    icon: icons.SingleChoice,
    group: 'select',
    haveLabel: true,
    canBeRequired: true,
    haveOptions: true,
    canBeRedacted: true,
    canBeReportable: true,
  },
  {
    type: ItemsTypes.MultipleChoice,
    name: 'Multiple choice',
    icon: icons.MultipleChoice,
    group: 'select',
    haveLabel: true,
    canBeRequired: true,
    haveOptions: true,
    canBeRedacted: true,
    canBeReportable: true,
  },
  {
    type: ItemsTypes.Line,
    name: 'Line',
    icon: icons.Line,
    group: 'layout',
  },
  {
    type: ItemsTypes.TwoColumnLayout,
    name: 'Two column layout',
    icon: icons.TwoColumnsLayout,
    group: 'layout',
    childItemsCount: 2,
    isContainer: true,
  },
  {
    type: ItemsTypes.ThreeColumnLayout,
    name: 'Three column layout',
    icon: icons.ThreeColumnsLayout,
    group: 'layout',
    childItemsCount: 3,
    isContainer: true,
  },
  {
    type: ItemsTypes.FileUpload,
    name: 'File upload',
    icon: icons.FileUpload,
    haveLabel: true,
    haveDescription: true,
    canBeRequired: true,
    haveFileFormats: true,
    canBeRedacted: true,
    canBeReportable: true,
  },
  {
    type: ItemsTypes.Hint,
    name: 'Hint',
    icon: icons.Hint,
    haveText: true,
    canBeRedacted: true,
  },
  {
    type: ItemsTypes.Video,
    name: 'Video',
    icon: icons.Video,
    haveVideoLink: true,
    canBeRedacted: true,
    canBeReportable: true,
  },
  {
    type: ItemsTypes.Signature,
    name: 'Signature',
    icon: icons.Signature,
    haveLabel: true,
    canBeRequired: true,
    canBeRedacted: true,
  },
];

class Toolbar extends React.Component {
  constructor(props) {
    super(props);
    this.create = this.create.bind(this);
  }

  componentDidMount() {
    store.subscribe(state => this.setState({ store: state }));
  }

  addCustomOptions(item, elementOptions) {
    if (item.type === 'custom') {
      const customOptions = Object.assign({}, item, elementOptions);
      customOptions.custom = true;
      customOptions.component = item.component || null;
      customOptions.custom_options = item.custom_options || [];
      return customOptions;
    }
    return elementOptions;
  }

  create(item) {
    const elementKey = item.element || item.key;
    const elementOptions = this.addCustomOptions(item, {
      id: ID.uuid(),
      element: elementKey,
      type: item.type,
      name: item.name,
      group_name: item.group_name,
      static: item.static,
      canBeRedacted: item.canBeRedacted,
      isContainer: !!item.isContainer,
    });

    if (item.haveSize) elementOptions.size = Sizes.Medium;

    if (item.haveText) elementOptions.text = '';

    if (item.haveLabel) elementOptions.label = '';

    if (item.canBeValidated) elementOptions.validation = null;

    if (item.canBeRequired) elementOptions.required = false;

    if (item.havePlaceholder) elementOptions.placeholder = '';

    if (item.haveDescription) elementOptions.description = '';

    if (item.haveOptions) {
      elementOptions.options = [];
      elementOptions.registerId = this.props.registers?.[0]?.id || null;
      elementOptions.compliance = false;
      elementOptions.obligationSource = '';

      elementOptions.dependantsSorting = false;
      elementOptions.dependantsTriggers = [];
      elementOptions.dependantsTriggersMap = {};
      elementOptions.dependantsIds = [];
    }

    if (item.haveFileFormats) elementOptions.fileFormats = [];

    if (item.haveVideoLink) elementOptions.videoLink = '';

    if (item.canBeCompliant) {
      elementOptions.canBeCompliant = item.canBeCompliant;
    }

    if (item.childItemsCount) {
      elementOptions.childItems = Array(item.childItemsCount).fill(null);
    }

    if (item.hasOwnProperty('dependantsSorting')) {
      elementOptions.dependantsSorting = item.dependantsSorting;
    }

    if (item.canBeReportable) {
      elementOptions.reportable = false;
    }

    return elementOptions;
  }

  _onClick(item) {
    this.props.onAddItem(this.create(item));
  }

  render() {
    const groups = Object.entries(Object.groupBy(items, ({ group }) => group));

    return (
      <div
        ref={this.props._ref}
        className={cx(bt['col-md-3'], bt['float-right'], 'react-form-builder-toolbar')}
        style={{ height: '100%', overflow: 'auto' }}
      >
        <div className="flex flex-col gap-4 pb-2">
          {groups.map(([name, items]) => (
            <div key={name} className="flex flex-col gap-2">
              <div className="uppercase text-[12px] text-[#676767]">
                {name === 'undefined' ? 'Other elements' : name}
              </div>
              <ul className="flex flex-col gap-1">
                {items.map(item => (
                  <ToolbarItem
                    item={item}
                    key={item.type}
                    onClick={this._onClick.bind(this, item)}
                    onCreate={this.create}
                  />
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Toolbar;
